import { render, staticRenderFns } from "./confirmOrderGuest.vue?vue&type=template&id=332c82de&"
import script from "./confirmOrderGuest.vue?vue&type=script&lang=js&"
export * from "./confirmOrderGuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports